$('body').on(
    'click',
    'a[href^="#"]:not([href="#"]):not(.no-animation)',
    function animateScroll() {
        if (
            !$(this).closest('.list-alphabet').length &&
            !$(this).closest('.js-error-summary').length &&
            $(this).attr('href') !== '#top'
        ) {
            if (
                location.pathname.replace(/^\//, '') ===
                    this.pathname.replace(/^\//, '') &&
                location.hostname === this.hostname
            ) {
                let target = $(this.hash);
                target = target.length
                    ? target
                    : $(`[name=${this.hash.slice(1)}]`);

                const offset = $(this).data('scroll-offset') || 0;
                if (target.length) {
                    $('html,body').animate(
                        {
                            scrollTop:
                                target.offset().top - parseInt(offset, 10),
                        },
                        1000
                    );
                }
            }
        }
    }
);
